import { FE_MIGRATE_RETAILER_STORE_250210 } from "@faire/retailer-settings/FE_MIGRATE_RETAILER_STORE_250210";
import { useAssignSetting, useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { useEffect } from "react";
export var useSettingAndAssignMigrateRetailerStore = function() {
    var assignSetting = useAssignSetting(FE_MIGRATE_RETAILER_STORE_250210);
    useEffect(function() {
        assignSetting();
    }, [
        assignSetting
    ]);
    return useSetting(FE_MIGRATE_RETAILER_STORE_250210);
};
